export const ObjectTypeIds = {
  DEAL: '0-3',
  DEAL_REGISTRATION: '0-73',
  COMPANY: '0-2',
  PORTAL_OBJECT_SYNC_MESSAGE: '0-76'
};
export const CrmObjectTypes = {
  DEAL_REGISTRATION: 'DEAL_REGISTRATION',
  PORTAL_OBJECT_SYNC_MESSAGE: 'PORTAL_OBJECT_SYNC_MESSAGE'
};